import { render, staticRenderFns } from "./u-count-down.vue?vue&type=template&id=072523e7&scoped=true&"
import script from "./u-count-down.vue?vue&type=script&lang=js&"
export * from "./u-count-down.vue?vue&type=script&lang=js&"
import style0 from "./u-count-down.vue?vue&type=style&index=0&id=072523e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072523e7",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-count-down/u-count-down.vue"
export default component.exports